import { createAppResolverFactory } from './create-app-resolver.factory';

export const appResolver = createAppResolverFactory();
